import { render, staticRenderFns } from "./ModalObservacion.vue?vue&type=template&id=81d7796e&scoped=true&"
import script from "./ModalObservacion.vue?vue&type=script&lang=js&"
export * from "./ModalObservacion.vue?vue&type=script&lang=js&"
import style0 from "./ModalObservacion.vue?vue&type=style&index=0&id=81d7796e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d7796e",
  null
  
)

export default component.exports